import * as React from 'react'
import { IPeerGroupsProps, getPeerGroupData, IFilter } from 'app/components/visualizations/PeerGroups/lib/http'
import { Row, Col, Panel, Table } from 'react-bootstrap'
import { AssetAllocationByStrategy } from 'app/components/visualizations/PeerGroups/AssetAllocation/AssetAllocationByStrategy'
import { AssetAllocationByStyle } from 'app/components/visualizations/PeerGroups/AssetAllocation/AssetAllocationByStyle'
import { AssetAllocationCashFixed } from 'app/components/visualizations/PeerGroups/AssetAllocation/AssetAllocationCashFixed'
import { AssetAllocationEquities } from 'app/components/visualizations/PeerGroups/AssetAllocation/AssetAllocationEquities'
import { SubHeader } from 'app/components/tabs/SubHeader'
import { TabHeader } from 'app/components/tabs/header'
import AssetAllocationIndividual from 'app/components/visualizations/PeerGroups/AssetAllocation/AssetAllocationIndividual'
import TabFootnote from 'app/components/tabs/TabFootnote'

interface IAssetAllocationState {
  data: any[]
  currentPeerGroup: any
  filters: IFilter
}

export class AssetAllocation extends React.Component<IPeerGroupsProps, IAssetAllocationState> {
  state: IAssetAllocationState = {
    data: [],
    currentPeerGroup: {},
    filters: { assetLevel: 0 },
  }

  componentDidMount() {
    this.pullData(this.props.filters)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel) {
      this.setState({ filters: this.props.filters }, () => {
        this.pullData(this.props.filters)
      })
    }
  }

  pullData(filters: IFilter) {
    const requestBody = { action: 'getAssetAllocationTab', request: { assetLevel: filters.assetLevel } }
    getPeerGroupData(requestBody)
      .then((response: any[]) => {
        const currentPeerGroup = response.find((dataPoint) => dataPoint.filterId === this.props.filters.assetLevel)
        this.setState({ data: response, currentPeerGroup })
      })
      .catch(error => console.error(error))
  }

  render() {
    const { currentPeerGroup, data } = this.state
    const { assetLevel, assetName } = this.props.filters
    return (
      <div>
        <TabHeader filters={this.props.filters} label="Portfolio Strategy &amp; Asset Allocation" />
        <Row>
          <Col sm={12} md={6}>
            <AssetAllocationIndividual filters={{ assetLevel, assetName }} data={data} />
          </Col>
          <Col sm={12} md={6}>
            <Panel>
              <div className="panel-heading text-center">
                Total Holdings by Asset Class
            </div>
              <div className="panel-body">
                <Table className="fontSize1_7">
                  <tbody>
                    <tr>
                      <td style={{ padding: '20px 0px' }}>Cash</td><td>{currentPeerGroup && currentPeerGroup.Strat_T_V22_CashTotalText}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '20px 0px' }}>Fixed Income</td><td>{currentPeerGroup && currentPeerGroup.Strat_T_V22_FixedTotalText}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '20px 0px' }}>Equities</td><td>{currentPeerGroup && currentPeerGroup.Strat_T_V22_EquityTotalText}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '20px 0px' }}>Investments - Other&#42;</td><td>{currentPeerGroup && currentPeerGroup.Strat_T_V22_InvOthTotalText}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '20px 0px' }}>Other Assets</td><td>{currentPeerGroup && currentPeerGroup.Strat_T_V22_OtherAssetsTotalText}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Panel>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <p style={{ padding: '0 15px', fontStyle: 'italic' }}>{currentPeerGroup && currentPeerGroup.Strat_T_V22_Text3}</p>
            <p style={{ padding: '0 15px', fontStyle: 'italic' }}>{currentPeerGroup && currentPeerGroup.Strat_T_V22_Text1}</p>
            <p style={{ padding: '0 15px', fontStyle: 'italic' }}>{currentPeerGroup && currentPeerGroup.Strat_T_V22_Text2}</p>
          </Col>
        </Row>
        <SubHeader label="Asset Allocation by Asset Level" />
        <Row>
          <Col sm={12} md={9}>
            <AssetAllocationCashFixed filters={{ assetLevel, assetName }} data={data} />
          </Col>
          <Col sm={12} md={3} style={{ padding: '20px' }}>
            <p>{currentPeerGroup && currentPeerGroup.Strat_T_V20_AllocText1}</p>
            <p>{currentPeerGroup && currentPeerGroup.Strat_T_B_AllocText1}</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={3} style={{ padding: '30px' }}>
            <p>{currentPeerGroup && currentPeerGroup.Strat_T_V21_AllocText2}</p>
            <p>{currentPeerGroup && currentPeerGroup.Strat_T_V21_Text2}</p>
          </Col>
          <Col sm={12} md={9}>
            <AssetAllocationEquities filters={{ assetLevel, assetName }} data={data} />
          </Col>
        </Row>
        <SubHeader label="FoundationMark Portfolio Strategies" />
        <Row style={{ marginTop: '1.0rem' }}>
          <Col sm={12}>
            <Panel>
              <div className="panel-heading text-center fontSize1_7">
                <p>{currentPeerGroup && currentPeerGroup.Strat_T_B_StratIntro2}</p>
              </div>
            </Panel>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <AssetAllocationByStrategy filters={{ assetLevel, assetName }} data={data} />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <TabFootnote>
              <p>{currentPeerGroup && currentPeerGroup.Strat_T_B_StratIntro3}</p>
            </TabFootnote>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={3} className="text-left" style={{ padding: '30px' }}>
            <p>{currentPeerGroup && currentPeerGroup.Strat_T_B_StratText2}</p>
            <p>{currentPeerGroup && currentPeerGroup.Strat_T_V12_PortStratText1}</p>
          </Col>
          <Col sm={12} md={9}>
            <AssetAllocationByStyle filters={{ assetLevel, assetName }} data={data} />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <TabFootnote>
              <p>{currentPeerGroup && currentPeerGroup.Strat_T_V22_Text1}</p>
            </TabFootnote>
          </Col>
        </Row>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/app/containers/PeerGroups/tabs/AssetAllocation.tsx